import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import * as actions from '../../../actions';
import classes  from '../../../utils/cssClasses';

class BadgeClassList extends Component{
	componentDidMount(){
		this.props.fetchAssertions(this.props.badgeClass._id);
	}

	render(){
		const { badgeClass, assertions } = this.props;

		if (!assertions){
			return ( 
				<FontAwesomeIcon icon="spinner" spin  />
			 );
		}

		return (
			<div>
				<table className={classes('table')}>
					<thead className={classes('thead-dark')}>
						<tr>
							<th>Assignee</th>
							<th>Actions</th>
						</tr>
					</thead>
					<tbody>
						{assertions.map(assertion => {
							console.log(assertion);
							return(
									<tr key={assertion._id}>
										<td>
											<Link to={`/admin/badgeclasses/${badgeClass._id}/assertions/${assertion._id}`}>{assertion.name} ({assertion.recipient.identity}) </Link>
										</td>
										<td>
											<Link to={`/admin/badgeclasses/${badgeClass._id}/assertions/${assertion._id}`}>Edit</Link>
										</td>
									</tr>
								);
						})}
					</tbody>
				</table>
			</div>
		);
	}
}

function mapStateToProps({ assertions }){
	return { assertions };
}

export default connect(mapStateToProps,actions)(BadgeClassList);


// WEBPACK FOOTER //
// ./src/components/Backend/AssertionList/AssertionList.js